export const SET_PATRIMOINE_MENU = 'SET_PATRIMOINE_MENU';
export const SET_GESTCOM_MENU = 'SET_GESTCOM_MENU';
export const SET_LOGISTIC_MENU = 'SET_LOGISTIC_MENU';
export const SET_COMPTA_MENU = 'SET_COMPTA_MENU';
export const SET_BAUX_MENU = 'SET_BAUX_MENU';
export const SET_INDEX_SUB_MENU_OPEN = 'SET_INDEX_SUB_MENU_OPEN';
export const SET_ACTIVE_SUB_MENU = 'SET_ACTIVE_SUB_MENU';
export const SET_ACHAT_MENU = 'SET_ACHAT_MENU';
export const SET_STOCK_MENU = 'SET_STOCK_MENU';
